import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import type { PersonalLoanResponseItem } from "@/component/PersonalLoan/Calculator/types";
import { ButtonLegacy, List } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";
import type { PersonalLoanSmallCalculatorFormFields } from "../PersonalLoanSmallCalculator";

export type StepFields = {};

interface Props extends AbstractStepProps {
	result: PersonalLoanResponseItem;
	allValues: PersonalLoanSmallCalculatorFormFields;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { result, allValues } = this.props;

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-center text-white">
					<mark className="h4 d-inline-block mt-2 bg-white text-primary px-2">
						{formatText(allValues.loanAmount, "ft")} hitel {allValues.maturity} évre
					</mark>
					<div className="display-2 font-weight-bold mt-1">{formatText(result?.startInstallment, "ft")}</div>
					<div>Havi törlesztőtől</div>
					<div className="h5 font-weight-normal my-2">{formatText(result?.apr, "%")} THM-től</div>
					<div className="small">
						Beállításaid alapján ezekkel a<br /> kondíciókkal érhető el személyi kölcsön
					</div>
				</Card.Header>
				<Card.Body className="result-body">
					<div className="h4 text-center mt-2">
						A részletes eredményeidet
						<br />
						email-ben küldjük el, szakértőnk telefonon keresni fog a további részletekkel kapcsolatban.
					</div>
					<List itemStyle="tick" variant="primary" className="text-body">
						<List.Item>
							Milyen <strong>kamattal</strong>, teljes <strong>visszafizetéssel</strong> és{" "}
							<strong>induló költséggel</strong> számolhatsz?
						</List.Item>
						<List.Item>
							<strong>Mennyi idő</strong> alatt és <strong>milyen feltételekkel</strong> kaphatod meg a
							fenti hitelt?
						</List.Item>
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen felmerülő kérdésedben
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy type="submit" className={!form.getState().valid ? "disabled" : undefined}>
						Kérem az eredményeimet
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
